import { render, staticRenderFns } from "./NewDestination.vue?vue&type=template&id=380e2612"
import script from "./NewDestination.vue?vue&type=script&lang=js"
export * from "./NewDestination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports